'use client';

import { useMemo } from 'react';

/**
 * Keeps the previous reference while the value is unchanged in content. Charts are rebuilt
 * from scratch whenever their data changes, and callers usually pass `labels`/`dataset` as
 * inline literals — without this, every parent render would destroy and recreate the chart,
 * replaying its animation from zero.
 */
export function useStableValue<T>(value: T): T {
  const key = JSON.stringify(value);

  return useMemo(() => value, [key]);
}
